module.exports = __webpack_public_path__ + "static/img/back.cb888531.png";